import { getLocalizedStrings } from '../profileSettingsLocalizedStrings';
import classes from './notificationSettings.scss'; 
import overlayClasses from './sceOverlayStyle.scss';
//import ModalPopup from './Presentational/ModalPopup';
import EmailPreferences from './Presentational/ViewAllEmailPreferences';
import TextBox from "./Presentational/newMailText";
import NotificationTextSettings from './notificationTextSettingsContainer';
import NotificationVoiceSettings from './notificationVoiceSettingsContainer';
import SceButton from '../../Common/CommonComponents/sceButton';
import FocusTrap from  'focus-trap-react';

class ViewAllEmail  extends React.Component{

    constructor(props) {
        super(props);
        this.state = {
          editmail:false,Editbutton:false,viewallemails:false,viewallphones:false,viewallvoices:false,closemodal:false,editButtonPress:false,
          cancelButtonPress:false,addIconPress:false,saveCancelButtonPress:false,inputEmail:"",addError:"",isNewEmailValid:"",
          enteredEmail:"",editEmail:"",emailExistErrMsg:"",modifyError:"",addressGuid:"",reqObj:{},doneEnableMail:true,
          addFlag:"",deleteFlag:"",saveCall:"",newMail:"",emailIds:[],oldEmailIds:[],voice:[],text:[],addContactToggleStatus: { 'email': false, 'voice': false, 'text': false },
          preferenceError:[],
          emailErr:false, lastEAPreference:false, emailPrefErr:false,removeEmail:'',paperlessEnrolled:'',addEmailExistErrMsg:'', viewAllMail:false,seqNo:'',disabledSave:"",
        };
        this.strings = getLocalizedStrings('NotificationSettings');
        this.setWrapperRef = this.setWrapperRef.bind(this);
        this.handleClickOutside = this.handleClickOutside.bind(this);
        this.emailIcon = drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/Icon_MailOn.svg';
        this.addIcon = drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/Action_Add.svg';
        this.removeIcon = drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/Action_Remove.svg';
        this.editIcon = drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/editIcon.svg';
        this.textIcon = drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/Icon_TextOn.svg';
        this.voiceIcon = drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/Icon_PhoneOn.svg';
        this.closeIcon = drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/Icon_Close.svg';
        this.mainBpNumber='';
        this.CACTCount='';
      }
      componentWillMount(){
        if(app.appService.isAuthenticated() || app.appService.isCpcGuestUser()){
          let accountData = app.appService.getUserInfo().profileData.accountData;
          let isValidBPNumber = !_.isEmpty(accountData);
          this.mainBpNumber = (isValidBPNumber && accountData.mainBusinessPartner!==null) ? accountData.mainBusinessPartner.businessPartnerNumber : this.props.bpNumber;
 
          app.profileSettingsService.getNotificationDetails(this.mainBpNumber).then((response) => {
            if (response.errorCode !== undefined && response.errorCode !== '') {
              this.setState({emailIds: '' });
            }
            else{
             
              let list = response.phoneNumbers.filter(record => record.indicatorSmsEnabled === 'X');
              this.CACTCount=response.contractAccountCount;
              
              this.setState({text :list,emailIds: response.emailAddresses,voice: response.phoneNumbers,addressGuid:response.addressGuid, count:response.emailAddresses.length });
            }
          });
        }
      }
       componentDidMount() {

        document.addEventListener('mousedown', this.handleClickOutside);
       }
      componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
      }
    
      setWrapperRef(node) {
        this.wrapperRef = node;
       }
    
      handleClickOutside(event) {
        if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
        this.props.cancelViewAllMailButtonHandler();
    
        }
      } 
      refreshNotification(){
        app.profileSettingsService.getNotificationDetails(this.mainBpNumber).then((response) => {
          if (response.errorCode !== undefined && response.errorCode !== '') {
            this.setState({emailIds: '' });
          }
          else{
            let list = response.phoneNumbers.filter(record => record.indicatorSmsEnabled === 'X');
            this.setState({text :list,emailIds: response.emailAddresses,voice: response.phoneNumbers,addressGuid:response.addressGuid,count:response.emailAddresses.length});
          }
        });
      }
      getEnrollDetails(bpNumber,emailId){
        app.profileSettingsService.getEnrollDetails(bpNumber,emailId,"INT").then((response) => {
          if (response.errorCode !== undefined && response.errorCode !== '') {
            //err
          } else {
            this.setPreference(response.impactedDevice, response.lastEAPreference);
          if(this.state.preferenceError.length>0 && this.state.removeEmail){
        
            this.setState({emailErr:true}) ;}
          if(this.state.preferenceError.length>0 && this.state.editEmail){
        
              this.setState({emailPrefErr:true}) ;}
         
          } });
      }
      setPreference(preferences, lastEAPreference) {
        const updatedState = { ...this.state };
        updatedState.preferenceError = [];
        updatedState.lastEAPreference = lastEAPreference;
        if(lastEAPreference && this.state.removeEmail){
          updatedState.preferenceError.push('Emergency Alerts');
        }
        else {
        preferences.map((preference) => {
          if (preference.category === 'DEMR' && preference.messageType === 'CPP1') {
            updatedState.preferenceError.push('Critical Peak Pricing Notifications');
          } else if (preference.category === 'PROG' && preference.messageType === 'BUDA') {
            updatedState.preferenceError.push('Budget Assistance Notifications');
          }
          else if (preference.category === 'PAPR' && preference.messageType === 'EBIL') {
            updatedState.preferenceError.push('Paperless Billing');
          } else if (preference.category === 'OUTG' && preference.messageType === 'OUTG') {
            updatedState.preferenceError.push('Repair and Maintenance Alerts');
          }
          else if (preference.category === 'OUTG' && preference.messageType === 'EMRG') {
          updatedState.preferenceError.push('Emergency Alerts');
        }
        });
      }
        updatedState.preferenceError = [...new Set(updatedState.preferenceError)];
        this.setState(updatedState);
      }
      removeHandler(e,emailId){
        const updatedState={...this.state};
        updatedState.emailErr=false;
        updatedState.removeButtonPress=true;
        updatedState.addIconPress=false;
        updatedState.editButtonPress=false;
        updatedState.removeEmail=emailId;
        updatedState.doneEnableMail=false;
        this.getEnrollDetails(this.mainBpNumber,emailId);
        this.setState(updatedState);
      }
      //Delete button click functionality
      removeButtonHandler(e,sn){
        if(this.state.pb === this.state.removeEmail ){
    //de enroll from PB
        }
        let reqObj={ "deviceType":"email","addressGuid":this.state.addressGuid,"modifiedValue": this.state.removeEmail,
         "sequenceNumber": sn};
        app.profileSettingsService.modifyCustomerPreference(this.mainBpNumber, reqObj, null, true).then(response => {
          if (response.errorCode && response.errorCode !== ''){
            this.setState({modifyError: true});
          }else{
            this.refreshNotification();
        const updatedState = { ...this.state };
       updatedState.removeButtonPress=false;
       updatedState.doneEnableMail=true;
       updatedState.modifyError=false;
       this.setState(updatedState);
          }
        });
      }
      editHandler(e,email,sequenceNumber){
        const updatedState = { ...this.state };
        updatedState.editButtonPress = true, updatedState.seqNo=sequenceNumber, updatedState.editEmail=email, updatedState.newMail="",updatedState.emailExistErrMsg="", updatedState.addIconPress=false, updatedState.emailPrefErr=false,
        updatedState.doneEnableMail=false, this.setState(updatedState);
        this.getEnrollDetails(this.mainBpNumber,email);
    }
    cancelButtonHandler = () => {
      const updatedState = { ...this.state };
      updatedState.cancelButtonPress = true,updatedState.editButtonPress = false,updatedState.emailExistErrMsg="", updatedState.doneEnableMail=true,this.setState(updatedState);
      
    }
    emailCallback(emailValue){
      const updatedState = { ...this.state };
      updatedState.enteredEmail=emailValue;
      updatedState.emailExistErrMsg="";
      this.setState(updatedState,
      ()=>{this.validateEmail(this.state.enteredEmail);});
    }
    validateEmail(emailId){
      let regex = new RegExp(/[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,15}/g);
      let emailVal=emailId;
      const updatedState = { ...this.state };
      if ( regex.test(emailVal) ) {
         updatedState.disabledSave=false,this.setState(updatedState);}
      else {
         updatedState.disabledSave=true,this.setState(updatedState);
      }}
  
    saveButtonHandler(){
       const updatedState={...this.state};
      updatedState.oldEmailIds=this.state.emailIds;
   let  emailId=this.state.enteredEmail!=="" ? this.state.enteredEmail : this.state.editEmail;
    
    if(!this.ifEmailExists(emailId)) {
      updatedState.modifyError=false,updatedState.editButtonPress = false,updatedState.addIconPress=false,updatedState.newMail=this.state.enteredEmail,updatedState.enteredEmail="",updatedState.emailExistErrMsg="",updatedState.doneEnableMail=true,this.setState(updatedState);
      this.props.verifyHandler(emailId,'ViewAllEmail','U','',this.state.seqNo);
    }else{
      this.setState({emailExistErrMsg:this.strings.emailExistsErr});      
    }   
    }
    ifEmailExists(emailId) {
      let emailExist=false;
      _.each(this.state.emailIds, function (record) {
        if (record.email.toLowerCase() === emailId.toLowerCase())
          emailExist=true;});
        return emailExist;
    }
    removeCancelHandler(){
      const updatedState={...this.state};
      updatedState.removeButtonPress=false;
      updatedState.doneEnableMail=true,
      this.setState(updatedState);
    }
    doneViewAllEmailButtonHandler(){
        this.props.cancelViewAllMailButtonHandler();
      }
  render(){
  return (
    <FocusTrap
    focusTrapOptions={{
      allowOutsideClick: true,
  }}

    >
    <div>

<div tabIndex="0" className={[overlayClasses.sceOverlay, classes.sceSetNotificationsDialog].join(' ')}>
    <div className={overlayClasses.sceOverlayContent}>
        <div  ref={this.setWrapperRef} className={overlayClasses.sceDialogBox}>
            <div className='row'>

                <div className={'col-xs-12 ' + classes.sceSetNotificationMainHeader}>{this.strings.viewAllEmailTitle} {'('}{this.state.count}{')'}

                <button className={classes.sceImageCloseButton} onClick={this.props.cancelViewAllMailButtonHandler} aria-label="Close icon"><img src={this.closeIcon} alt="Close Icon" />
                </button>
                </div>
            </div>
            <div className={classes.viewAllScrollableContent}>
            <EmailPreferences verificationSuccessful={this.state.verificationSuccessful} verifyHandler={this.props.verifyHandler} disabledSave={this.state.disabledSave} preferenceDetails={this.state.preferenceDetails} CACTCount={this.CACTCount} data={this.state} removeHandler={this.removeHandler.bind(this)} removeCancelHandler={this.removeCancelHandler.bind(this)} removeButtonHandler={this.removeButtonHandler.bind(this)} editHandler={this.editHandler.bind(this)} editButton={this.state.editButtonPress} editEmail={this.state.editEmail}
                cancelButtonHandler={this.cancelButtonHandler.bind(this)} emailCallback={this.emailCallback.bind(this)} enteredEmail={this.state.enteredEmail} saveButtonHandler={this.saveButtonHandler.bind(this)}
                emailExistErrMsg={this.state.emailExistErrMsg} modifyError={this.state.modifyError} totalAccounts={this.CACTCount} newMail={this.state.newMail} viewAllMail={this.props.viewAllMail} />
            </div>
            

            <div className="text-align-center">

                <div className={classes.footerButton}>
                    <div className={classes.turnOnBtn}>
                    {this.state.doneEnableMail ?  

                        <SceButton
                            buttonType="primary"
                            value="Done"
                            onClick={this.doneViewAllEmailButtonHandler.bind(this)}
                        />
                        :
                        <SceButton
                        buttonType="sceDisabled"
                        value="Done"
                        onClick={this.doneViewAllEmailButtonHandler.bind(this)}
                    />
                    }



                    </div>
                </div>

            </div>
        </div>
    </div>
</div>





</div>  
</FocusTrap>  
     );}
}
export default ViewAllEmail;